import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppRoutes } from '../../Router';
import { Survey } from '../../components';
import { ActionSegment, SurveyName, SurveyType } from '@reviews/interfaces';
import segmentService from '../../services/segment/segmentService';
import { FrontendUtils } from '@reviews/frontend';
import { Spinner } from '../../assests/icons';

export const ContentSurveyView: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const tracked = useRef(false);

    const reservationId = searchParams.get('reservation');
    const confirmationCode = searchParams.get('confirmation') ?? '';
    const nsuHash = searchParams.get('nsu') ?? '';
    const isPal = true;

    useEffect(() => {
        FrontendUtils.SharedUtils.setBaseItemForTracking(reservationId, confirmationCode, nsuHash, '', '');
        if (!tracked.current) {
            segmentService.trackPage();
            segmentService.trackEvent({
                action: ActionSegment.PAGE_LOAD,
                reservation_id: reservationId,
                confirmation_code: confirmationCode,
                nsu: nsuHash,
                survey_name: SurveyName.DURING_STAY_CONTENT,
            });
            tracked.current = true;
        }
    }, [confirmationCode, nsuHash, reservationId]);

    useEffect(() => {
        if (!reservationId) {
            navigate(AppRoutes.HOME);
        }
    }, [navigate, reservationId]);

    if (!reservationId) {
        return (
            <div className="loading">
                <Spinner />
            </div>
        );
    }

    const footer = document.getElementById('footer');
    if (footer) {
        footer.classList.remove('fixed-bottom');
    }

    return (
        <Survey
            reservationId={+reservationId}
            confirmationCode={confirmationCode}
            nsuHash={nsuHash}
            type={SurveyType.CONTENT}
            surveyName={SurveyName.DURING_STAY_CONTENT}
            commentRequired={false}
            isPal={isPal}
        />
    );
};
